import { CloseButton, Stack, Typography } from "@compass/core";
import { TextingQueueDetailDto } from "generated/openApi";
import { TextingStatusChip } from "../TextingStatusChip";

export const TextingQueueDetailPageHeader = (props: { textingQueue: TextingQueueDetailDto }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Stack direction="row" spacing="sm" alignItems="center">
      <Typography variant="inherit">
        {props.textingQueue.name || `Texting Queue #${props.textingQueue.id}`}
      </Typography>
      {props.textingQueue.status && <TextingStatusChip status={props.textingQueue.status} />}
    </Stack>
    <CloseButton />
  </Stack>
);
